const buildType = require("./models");

module.exports = buildType({
  initializer: (model, document) => {
    model.name = document?.name;
    model.country = document?.country;
    model.apiKeys = document?.apiKeys ?? [];
  },
  save: async (bank, create, update, database) => {
    const accounts = await database.getList("bankAccounts");
    for (const account of accounts) {
      if (account.bank?.id === bank.id) {
        account.bank = { ...bank };
        await database.set("bankAccounts", account.id, account);
      }
    }
    if (!(await update("banks", bank))) {
      await create("banks", bank);
    }
  },

  code: "banks",
  singular: "Bank",
  plural: "Banks",
});
